var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"width":"100%","height":"100vh","overflow":"hidden","background":"#fff"},attrs:{"src":_vm.scormUrl,"allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }